import type { AvatarTone } from '../model/types'

/** Background + label class pairs for each avatar tone (theme tokens). */
export const AVATAR_TONE_CLASS: Record<AvatarTone, string> = {
  purple: 'bg-avatar-purple-soft text-avatar-purple',
  amber: 'bg-avatar-amber-soft text-avatar-amber',
  green: 'bg-avatar-green-soft text-avatar-green',
  blue: 'bg-avatar-blue-soft text-avatar-blue',
  red: 'bg-avatar-red-soft text-avatar-red',
  gray: 'bg-paper-avatar text-gray-500',
}

/** Tones used for ordinary contacts (danger is reserved for missed/failed). */
const HASHABLE_TONES: AvatarTone[] = ['purple', 'amber', 'green', 'blue']

/** Deterministically derive an avatar tone from a contact title. */
export function pickAvatarTone(seed: string): AvatarTone {
  let hash = 0
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash << 5) - hash + seed.charCodeAt(i)
    hash |= 0
  }
  return HASHABLE_TONES[Math.abs(hash) % HASHABLE_TONES.length]
}

/** Initials from a contact name (first letters of the first two words). */
export function getInitials(value: string): string {
  return value
    .split(' ')
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join('')
    .toUpperCase()
}
